import { Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'
import { useLayout } from 'hooks/useLayout'

export const OrganizationDetailsTabs = ({
  organizationId,
  currentTab,
}: {
  organizationId: number
  currentTab: string
}) => {
  const { isMobile } = useLayout()
  return (
    <Tabs value={currentTab} variant={isMobile ? 'fullWidth' : 'standard'}>
      <Tab
        label="Overview"
        value={`/ClientManagement/Organizations/${organizationId}`}
        to={`/ClientManagement/Organizations/${organizationId}`}
        component={Link}
      />
      <Tab
        label="Specials & Events"
        value={`/ClientManagement/Organizations/${organizationId}/OrganizationSpecialsEvents`}
        to={`/ClientManagement/Organizations/${organizationId}/OrganizationSpecialsEvents`}
        component={Link}
      />
    </Tabs>
  )
}
